import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Cushion,
  FlexContainer,
  Panel,
  Rectangle,
  ScrollBox,
  Typography,
} from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';
import TokenRedirect from '../token-redirect-link/route';

const JoinClubPanel = ({ isOpen, onClose }) => (
  <Panel isOpen={isOpen} onClose={onClose}>
    <Rectangle fill="seashellgrey" component="div" style={{ height: '100%' }}>
      <ScrollBox yOnly>
        <Cushion horizontal="medium" vertical="xlarge">
          <FlexContainer flexDirection="column" alignItems="center">
            <Typography align="center" preset="title" color="black" component="div">
              <Trans i18nkey="common:join_to_set_availability">Join to set availability</Trans>
            </Typography>
            <Cushion vertical="medium">
              <Typography align="center" preset="body--small">
                <Trans i18nkey="common:join_club_availability">
                  You need to become a player at this club before you can set your availability
                </Trans>
              </Typography>
            </Cushion>
            <Button theme="primary">
              <TokenRedirect route="join">
                <Trans i18nkey="common:join_club">Join this club</Trans>
              </TokenRedirect>
            </Button>
          </FlexContainer>
        </Cushion>
      </ScrollBox>
    </Rectangle>
  </Panel>
);

JoinClubPanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default JoinClubPanel;
